module.exports = __webpack_public_path__ + "img/ilustraviz_logo.0cc50a22.png";